export enum KEYS {
    starcat = "starcat",
    aboutUs = "aboutUs",
    zero = "zer0rachunków",
    contact = "contact",
    welcome = "welcome",

    privacy = "privacy",
}
